import styled from "styled-components"

export default {
    "Main": styled.main`
        display: flex;
        flex-grow: 1;
    `
}